package pl.decks.chartjs.silk.radar

import com.varabyte.kobweb.compose.ui.graphics.Color

data class SilkRadarDefaults(
    val gridColor: Color,
    val tickColor: Color,
    val angleLinesColor: Color,
    val pointLabelColor: Color,
    val backdropColor: Color,
    val legendLabelColor: Color,
    val chartBackgroundColor: Color,
)
